( function ( _s ) {
	_s.fn.table = function () {
		return this.el.forEach( el => {
			const _table = _s( el );

			_table.wrap( '<div class="table-wrapper"></div>' );
		} );
	};

	_s( document ).ready( () => {
		const _elements = _s( '#main table' );

		if ( _elements.length ) {
			_elements.table();
		}
	} );
} )( window._s );
